import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'base-button',
      _ctx.isCancel ? 'cancel' : 'principal',
      _ctx.isFilter ? 'filter' : '',
      _ctx.isDisabled ? 'disabled' : '',
      _ctx.isSelected ? 'selected' : '',
    ]),
    disabled: _ctx.isDisabled
  }, _toDisplayString(_ctx.buttonLabel), 11, _hoisted_1))
}